/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import StudentRouteLinkItem from './StudentRouteLinkItem';
import AttendanceIcon from 'icons/AttendanceIcon';

const messages = defineMessages({
  title: {id: 'navigation.attendance'},
});

const AttendanceItem = () => (
  <StudentRouteLinkItem
    iconBefore={AttendanceIcon}
    route="midas/student/attendance"
    title={messages.title}
  />
);

export default AttendanceItem;
